module.exports = __webpack_public_path__ + "static/media/sun.68e470fb.png";